import _typeof from "@babel/runtime/helpers/typeof";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.assign.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.starts-with.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.concat.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.includes.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.includes.js";
import T from "../../../../../axios@1.7.7/node_modules/axios/lib/axios.js";
import { LS as w } from "../../../../../@mx_fsp-mweb-utils@0.125.0/node_modules/@mx/fsp-mweb-utils/dist/index.esm.js";
function A(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function E(t, e, o) {
  return Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function I(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && h(t, e);
}
function d(t) {
  return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, d(t);
}
function h(t, e) {
  return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (r, n) {
    return r.__proto__ = n, r;
  }, h(t, e);
}
function S() {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused) {
    return !1;
  }
}
function O(t, e, o) {
  return S() ? O = Reflect.construct.bind() : O = function O(n, c, i) {
    var l = [null];
    l.push.apply(l, c);
    var v = Function.bind.apply(n, l),
      s = new v();
    return i && h(s, i.prototype), s;
  }, O.apply(null, arguments);
}
function M(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function _(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */new Map() : void 0;
  return _ = function _(r) {
    if (r === null || !M(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (_typeof(e) < "u") {
      if (e.has(r)) return e.get(r);
      e.set(r, n);
    }
    function n() {
      return O(r, arguments, d(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), h(n, r);
  }, _(t);
}
function q(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function D(t, e) {
  if (e && (_typeof(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return q(t);
}
function N(t) {
  var e = S();
  return function () {
    var r = d(t),
      n;
    if (e) {
      var c = d(this).constructor;
      n = Reflect.construct(r, arguments, c);
    } else n = r.apply(this, arguments);
    return D(this, n);
  };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function X(t, e) {
  var o = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (o[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var n = 0, r = Object.getOwnPropertySymbols(t); n < r.length; n++) e.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[n]) && (o[r[n]] = t[r[n]]);
  return o;
}
var m;
(function (t) {
  t[t.TOAST = 1] = "TOAST", t[t.MODAL = 2] = "MODAL", t[t.MODAL_EXIT = 3] = "MODAL_EXIT", t[t.EXIT = 4] = "EXIT";
})(m || (m = {}));
var y = /* @__PURE__ */function (t) {
  I(o, t);
  var e = N(o);
  function o(r, n, c) {
    var i;
    return A(this, o), i = e.call(this, r), i.level = n, i.code = c, i;
  }
  return E(o);
}(/* @__PURE__ */_(Error));
function K(t) {
  var e = t.method,
    o = t.params,
    r = t.data,
    n = t.headers,
    c = n === void 0 ? {} : n,
    i = t.url,
    l = X(t, ["method", "params", "data", "headers", "url"]),
    v = Object.assign({}, c);
  if (!i) throw new Error("缺少请求地址");
  var s = i,
    R = window.location.host,
    g = window.location.protocol;
  i.startsWith("//") ? s = "".concat(g).concat(i) : i.startsWith("/") && (s = "".concat(g, "//").concat(R).concat(i));
  var f = Object.assign({
      url: s,
      method: e || "get",
      timeout: 1e4,
      withCredentials: !0,
      headers: Object.assign({}, v),
      responseType: "json"
    }, l),
    j = f.method;
  j && ["post", "put"].includes(j.toLowerCase()) ? (f.data = r, f.params = o) : f.params = Object.assign(Object.assign({}, r), o);
  var b = f.url;
  if (t.useCache && w.get(b)) {
    T(f).then(function (a) {
      var u = a.data;
      if (u.error) {
        var p = u.error;
        throw new y(p.message, p.level, p.code);
      }
      u && w.set(b, u);
    });
    var x = JSON.parse(w.get(b)),
      P = x.data;
    if (P) return P;
  }
  return T(f).then(function (a) {
    var u = a.data;
    if (u.error) {
      var p = u.error;
      throw new y(p.message, p.level, p.code);
    }
    if (u) return u;
  }).catch(function (a) {
    throw a.message.includes("timeout") && (a = new y("接口超时，请重试", m.TOAST, 0)), a.level || (a = new y("接口返回异常，请重试", m.TOAST, 0)), a;
  });
}
export { m as ErrorLevel, K as default };
